<template>
  <v-app-bar
    app
    :clipped-left="$store.getters.hasContextTabs"
    :color="$colors.penChecksNavyBlue"
    dark
    :class="{ darkNavyBanner: useDarkNavyBanner }"
    :height="useDarkNavyBanner ? BANNER_HEIGHT : HEIGHT"
    elevation="0"
  >
    <v-row class="px-8">
      <template v-if="!isShowTopRightMenu">
        <a
          class="banner-link"
          href="#"
          @click.prevent="onLogoClicked"
          data-id="5ab4bacf385d37ecfb49e531a483cbe3"
        >
          <img
            v-if="usePenchecksTrustLogo"
            style="margin-top: 6px"
            height="37"
            src="@/auth/assets/penchecks-logo-white.svg"
          />
          <div v-else style="display: inline-flex">
            <img
              class="mt-1"
              height="32"
              src="@/advisor/assets/next-level-ira-logo-only-color.svg"
            />
            <div class="ml-2 mt-2">
              <span class="banner-title">Advisor Portal</span>
            </div>
          </div>
        </a>
      </template>
      <pc-advisor-context-tabs
        v-if="isShowTopRightMenu"
      ></pc-advisor-context-tabs>
      <v-spacer></v-spacer>
      <div v-if="isShowTopRightMenu && $store.state.authenticatedUser">
        <v-menu offset-y content-class="right-menu">
          <template v-slot:activator="{ on }">
            <v-btn
              id="authenticatedUserEmailAddressButton"
              text
              v-on="on"
              style="text-transform: none"
              data-id="220c8aa9da1a6312e049c6c000639799"
            >
              {{ $store.state.authenticatedUser.emailAddress | lowercase }}
              <v-icon class="menu-arrow">fal fa-angle-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item to="/user-settings">
              <v-list-item-content>
                <v-list-item-title id="userSettingsListItemTitle">
                  <span class="menu-item-icon">
                    <pc-icon
                      id="userSettingsIcon"
                      name="pc-entity-user"
                      size="16"
                      width="32"
                      data-id="a40472a0e890b8c86be5bb554eedfc7c"
                    ></pc-icon>
                  </span>
                  User Settings
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="onLogoutUserClicked()">
              <v-list-item-content>
                <v-list-item-title id="logOutButton">
                  <span class="menu-item-icon">
                    <pc-icon
                      id="logOutIcon"
                      name="pc-log-out"
                      size="16"
                      width="32"
                      data-id="ec75303bcd741c405e98d07441c34cad"
                    ></pc-icon>
                  </span>
                  Logout
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title data-id="d02e81bbb47c20d686af7cd85f2efffa">
                  <pc-version />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <pc-button
        v-if="isShowButton"
        class="mt-1"
        @click="onButtonClicked"
        :color="$colors.white"
        :id="buttonId"
        text
        medium
        data-id="bf50df1b58d6294a0b5d017151e131d8"
        >{{ buttonText }}</pc-button
      >
    </v-row>
  </v-app-bar>
</template>

<script>
import PcVersion from "@/shared/components/PcVersion";
import User from "@/shared/lib/client-sdk/models/user";
import PcAdvisorContextTabs from "@/advisor/components/layout/PcAdvisorContextTabs";

// Exported because the drawer beside this bar sits below it and cannot ask Vuetify how tall it
// is: `$vuetify.application.top` sums every mounted app bar, and the page-level sticky header is
// one of those without being above the drawer.
export const HEIGHT = 48;
export const BANNER_HEIGHT = 70;

export default {
  components: {
    PcVersion,
    PcAdvisorContextTabs,
  },

  props: {
    simple: {
      type: Boolean,
      required: false,
      default: false,
    },
    isShowButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonText: {
      type: String,
      required: false,
      default: "Cancel",
    },
    buttonId: {
      type: String,
      required: false,
      default: "idButtonTopRight",
    },
    useDarkNavyBanner: {
      type: Boolean,
      required: false,
      default: false,
    },
    usePenchecksTrustLogo: {
      type: Boolean,
      required: false,
      default: false,
    },
    isShowTopRightMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return { HEIGHT, BANNER_HEIGHT };
  },

  computed: {
    hasLogoClickListener: function () {
      return this.$listeners && this.$listeners["logo-click"];
    },

    hasButtonClickListener: function () {
      return this.$listeners && this.$listeners["button-click"];
    },

    hasLogoutUserClickListener: function () {
      return this.$listeners && this.$listeners["logout-user-click"];
    },
  },

  methods: {
    onLogoClicked: function () {
      if (this.hasLogoClickListener) {
        this.$emit("logo-click");
      } else {
        document.location = "/";
      }
    },
    onButtonClicked: function () {
      if (this.hasButtonClickListener) {
        this.$emit("button-click");
      } else {
        document.location = "/";
      }
    },
    logoutAuthenticatedUser() {
      User.logoutAuthenticatedUser(() => {
        this.$store.commit("removeAuthenticatedUser");
        document.location = window.amplifyRuntimeConfig.get(
          "VUE_APP_ADVISOR_BASE_URL"
        );
      });
    },
    onLogoutUserClicked: function () {
      if (this.hasLogoutUserClickListener) {
        this.$emit("logout-user-click");
      } else {
        this.logoutAuthenticatedUser();
      }
    },
  },
};
</script>

<style lang="scss">
.right-menu {
  .v-list-item__content .v-list-item__title {
    font-size: 14px !important;
  }
}

.menu-item-icon {
  display: inline-block;
  width: 40px;
}

.menu-arrow {
  margin-left: 10px;
}

.banner-link {
  text-decoration: none;
}

.darkNavyBanner {
  background-color: #0c223a !important;
}

.banner-title {
  color: $white;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 400;
  line-height: 28.13px;
  text-align: left;
  text-decoration: none;
}
</style>
